<template>
  <transition name="toast" @enter="onEnter">
    <div v-if="showToast" :class="toastClasses">
      <p>{{ message }}</p>
    </div>
  </transition>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class ToastNotification extends Vue {
  // Props
  @Prop({ type: Boolean, default: false }) readonly showToast!: boolean
  @Prop({ type: String, default: 'ここにメッセージが表示されます。' })
  readonly message!: string
  @Prop({ type: Number, default: 2000 }) readonly duration!: number
  @Prop({
    type: String,
    default: 'info',
    validator: (value: string) => ['info', 'error'].includes(value),
  })
  readonly type!: 'info' | 'error'

  // Computed properties
  get toastClasses(): string[] {
    return ['toast-container', `toast--${this.type}`]
  }

  // Watchers
  @Watch('showToast')
  onShowToastChanged(isShown: boolean): void {
    if (isShown) {
      setTimeout(() => {
        this.close()
      }, this.duration)
    }
  }

  // Methods
  close(): void {
    this.$emit('update:showToast', false)
  }

  // Transition hooks
  onEnter(el: HTMLElement, done: () => void): void {
    // 1. アニメーションの初期状態を設定
    el.style.opacity = '0'
    el.style.transform = 'translate(-50%, -20px)'

    // 2. ブラウザに初期状態を強制的に描画させる (重要)
    void el.offsetHeight

    // 3. アニメーションの最終状態を設定 (transitionが適用される)
    el.style.opacity = '1'
    el.style.transform = 'translate(-50%, 0)'

    // 4. アニメーションが終わったらVueに通知する
    el.addEventListener('transitionend', done, { once: true })
  }
}
</script>

<style scoped>
.toast-container {
  position: fixed;
  z-index: 9999;
  top: 20px;
  left: 50%;
  padding: 12px 24px;
  color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  font-family: sans-serif;
  font-size: 14px;
  transition: all 0.4s ease;
}

.toast--info {
  background-color: rgba(24, 141, 255, 0.8);
}

.toast--error {
  background-color: rgba(255, 0, 61, 0.8);
}

.toast-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>
